import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackGoogleAnalyticsPageView } from '../../initGoogleAnalytics';

/** Sends GA4 page_view on each client-side route change (SPA). */
export function GoogleAnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const path =
      location.pathname + location.search + location.hash;
    trackGoogleAnalyticsPageView(path);
  }, [location]);

  return null;
}
